(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clean-video-banner"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('video-component').then(() => {
    if (customElements.get('clean-banner-video')) return;
    const ThemeVideo = customElements.get('video-component');
    class CleanBannerVideo extends ThemeVideo {
      connectedCallback() {
        this.toggle = this.querySelector('.bg-clean-banner__toggle');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onToggle = () => {
          if (!this.playerReady) return;
          if (this.dataset.playing === 'true') this.player.pauseVideo();
          else this.player.playVideo();
        };
        this.toggle.addEventListener('click', this.onToggle);
        super.connectedCallback();
      }
      loadYoutube() {
        if (this.player || !this.isConnected || !window.YT || !window.YT.Player) return;
        this.player = new window.YT.Player(this.id + '-player', {
          videoId: this.video_id,
          playerVars: {
            autoplay: this.reduceMotion ? 0 : 1,
            mute: 1,
            controls: 0,
            playsinline: 1,
            loop: 1,
            playlist: this.video_id,
            disablekb: 1,
            fs: 0,
            rel: 0,
            origin: window.location.origin
          },
          events: {
            onReady: ({target}) => {
              if (!this.isConnected) return;
              this.playerReady = true;
              target.mute();
              target.getIframe().setAttribute('tabindex', '-1');
              target.getIframe().setAttribute('aria-hidden', 'true');
              this.toggle.disabled = false;
              if (!this.reduceMotion) target.playVideo();
            },
            onStateChange: ({target, data}) => {
              const playing = data === window.YT.PlayerState.PLAYING;
              if (playing) this.dataset.started = 'true';
              if (playing || data === window.YT.PlayerState.PAUSED || data === window.YT.PlayerState.ENDED) {
                this.dataset.playing = String(playing);
                this.toggle.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
              }
              if (data === window.YT.PlayerState.ENDED) {
                target.seekTo(0);
                target.playVideo();
              }
            },
            onError: () => {
              this.dataset.started = 'false';
              this.dataset.playing = 'false';
              this.toggle.disabled = true;
            }
          }
        });
      }
      disconnectedCallback() {
        this.toggle.removeEventListener('click', this.onToggle);
        if (this.player) this.player.destroy();
        this.player = null;
        this.playerReady = false;
      }
    }
    customElements.define('clean-banner-video', CleanBannerVideo);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-product-fade"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!('IntersectionObserver' in window)) return;

    const mobile = window.matchMedia('(max-width: 767px), (hover: none)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selector = '.product-card--root[data-hover-image] .product-card--image-wrapper';
    const cards = new Map();
    const visible = new Set();
    let enabled = false;

    function sync(wrapper) {
      const state = cards.get(wrapper);
      const active = Boolean(enabled && !document.hidden && visible.has(wrapper) && state?.ready);
      if (wrapper.hasAttribute('data-mobile-fade-active') !== active) {
        wrapper.toggleAttribute('data-mobile-fade-active', active);
      }
    }

    async function prepare(wrapper) {
      const state = cards.get(wrapper);
      if (!state || !enabled) return;
      const image = state.image;
      if (!image.complete || image.naturalWidth <= 1) {
        state.ready = false;
        sync(wrapper);
        return;
      }
      const source = image.currentSrc;
      if (state.ready && state.source === source) return;
      const token = ++state.token;
      try {
        if (image.decode) await image.decode();
        if (cards.get(wrapper) !== state || state.token !== token) return;
        state.ready = image.complete && image.naturalWidth > 1 && image.currentSrc === source;
        state.source = source;
      } catch {
        if (cards.get(wrapper) !== state || state.token !== token) return;
        state.ready = false;
      }
      sync(wrapper);
    }

    const preloadObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = cards.get(entry.target);
        if (!enabled || !state || !entry.isIntersecting) return;
        state.image.loading = 'eager';
        prepare(entry.target);
        preloadObserver.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    const visibilityObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!enabled || !cards.has(entry.target)) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          visible.add(entry.target);
          prepare(entry.target);
        } else {
          visible.delete(entry.target);
        }
        sync(entry.target);
      });
    }, { threshold: [0, 0.25] });

    function register(wrapper) {
      if (cards.has(wrapper)) return;
      const image = wrapper.querySelector('.product-card--hover-image');
      if (!image || !wrapper.querySelector('.product-card--image')) return;
      const onLoad = () => prepare(wrapper);
      cards.set(wrapper, { image, ready: false, source: '', token: 0, onLoad });
      image.addEventListener('load', onLoad);
      image.addEventListener('error', onLoad);
      if (enabled) {
        wrapper.setAttribute('data-mobile-fade', '');
        preloadObserver.observe(wrapper);
        visibilityObserver.observe(wrapper);
      }
    }

    function scan(root) {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches?.(selector)) register(root);
      root.querySelectorAll(selector).forEach(register);
    }

    function refreshMode() {
      enabled = mobile.matches && !reducedMotion.matches;
      preloadObserver.disconnect();
      visibilityObserver.disconnect();
      visible.clear();
      cards.forEach((state, wrapper) => {
        wrapper.toggleAttribute('data-mobile-fade', enabled);
        sync(wrapper);
        if (enabled) {
          preloadObserver.observe(wrapper);
          visibilityObserver.observe(wrapper);
        }
      });
    }

    scan(document);
    refreshMode();
    new MutationObserver(mutations => {
      cards.forEach((state, wrapper) => {
        if (wrapper.isConnected && wrapper.contains(state.image)) return;
        preloadObserver.unobserve(wrapper);
        visibilityObserver.unobserve(wrapper);
        visible.delete(wrapper);
        cards.delete(wrapper);
        state.image.removeEventListener('load', state.onLoad);
        state.image.removeEventListener('error', state.onLoad);
      });
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          const wrapper = mutation.target.closest(selector);
          const state = cards.get(wrapper);
          if (!state || mutation.target !== state.image) return;
          state.ready = false;
          state.token++;
          sync(wrapper);
          prepare(wrapper);
          return;
        }
        mutation.addedNodes.forEach(scan);
        const wrapper = mutation.target.closest?.(selector);
        if (wrapper) register(wrapper);
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });

    document.addEventListener('visibilitychange', () => visible.forEach(sync));
    window.addEventListener('pageshow', refreshMode);
    mobile.addEventListener('change', refreshMode);
    reducedMotion.addEventListener('change', refreshMode);
  })();
  } catch(e) { console.error(e); }
})();

})();
